import { FaArrowRight } from "react-icons/fa6";

export default function ViewAll({ text, action, extraClass }) {
  return (
    <button
      onClick={action}
      className={`font-normal text-[#020202] 
                   flex justify-center items-center gap-4 
                 hover:text-blue-600 hover:border-b hover:border-b-blue-600 border-b border-b-white ${extraClass}`}
    >
      {text}
      <FaArrowRight />
    </button>
  );
}
